export default __webpack_public_path__ + "static/media/CryingCrocGif_v2.eb3640af.gif";